// Libraries
import Geolocation from '@react-x/geolocation';

import {GeolocationArgs} from './BackgroundGeolocationType';

// Native platform supplies a string (message) to the onError handler. This matches that.
const transformOnError = (onError: (msg: string) => void) => {
  return (error: {message: string}) => onError(error.message);
};

// Native platform takes in seconds.
const transformTimeout = (timeout?: number) => {
  return timeout ? timeout * 1000 : timeout;
};

const BackgroundGeolocation = {
  // HACK(mark): Storing state on a singleton isn't a good idea but works for now.
  watchId: undefined as number | undefined,

  start: async ({timeout, onSuccess, onError}: GeolocationArgs) => {
    console.log('[BackgroundGeolocation]: Starting...');

    // Initialize the watcher.
    BackgroundGeolocation.watchId = Geolocation.watchPosition(
      onSuccess,
      transformOnError(onError),
      {enableHighAccuracy: true, timeout: transformTimeout(timeout)},
    );

    console.log('[BackgroundGeolocation]: Successfully started.');
  },

  stop: async () => {
    Geolocation.clearWatch(BackgroundGeolocation.watchId as number);
  },

  getCurrentPosition: ({timeout, onSuccess, onError}: GeolocationArgs) => {
    console.log('[BackgroundGeolocation]: Fetching current position.');

    Geolocation.getCurrentPosition(onSuccess, transformOnError(onError), {
      enableHighAccuracy: true,
      timeout: transformTimeout(timeout),
    });
  },
};

export default BackgroundGeolocation;
